'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalClose = require('./ModalClose');

var _ModalClose2 = _interopRequireDefault(_ModalClose);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Normally, we'd style via CSS, but we need to override the defaults
// provided by ReactModal.
var REACT_MODAL_STYLES = {
  overlay: {
    backgroundColor: '#fff'
  },
  content: {
    position: 'static',
    top: 'auto',
    left: 'auto',
    right: 'auto',
    bottom: 'auto',
    border: 0,
    background: 'transparent',
    borderRadius: 0,
    padding: 0
  }
};

var _class = function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, _class);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.onCloseClick = function (event) {
      event.preventDefault();
      _this.requestClose();
    }, _this.requestClose = function () {
      if (_this.props.onRequestClose) {
        _this.props.onRequestClose();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(_class, [{
    key: '_renderClose',
    value: function _renderClose() {
      return _react2.default.createElement(_ModalClose2.default, { onClick: this.onCloseClick });
    }
  }, {
    key: 'render',
    value: function render() {
      var close = this.props.hideClose ? null : this._renderClose();
      return _react2.default.createElement(
        _reactModal2.default,
        {
          contentLabel: this.props.contentLabel,
          isOpen: this.props.isOpen,
          onRequestClose: this.props.onRequestClose,
          closeTimeoutMS: 150,
          ariaHideApp: true,
          style: REACT_MODAL_STYLES
        },
        close,
        this.props.children
      );
    }
  }]);

  return _class;
}(_react2.default.Component);

_class.displayName = 'Modal';
_class.propTypes = {
  children: _propTypes2.default.node,
  contentLabel: _propTypes2.default.string,
  isOpen: _propTypes2.default.bool,
  hideClose: _propTypes2.default.bool,
  onRequestClose: _propTypes2.default.func
};
_class.defaultProps = {
  contentLabel: 'Modal',
  isOpen: false,
  hideClose: false
};
_class.setAppElement = _reactModal2.default.setAppElement;
exports.default = _class;